"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearErrors = exports.clearError = exports.resetInvitationType = exports.editInvitationType = exports.saveInvitationTypeFail = exports.saveInvitationTypeSuccess = exports.saveInvitationType = exports.getInvitationTypesFail = exports.getInvitationTypesSuccess = exports.getInvitationTypes = exports.selectInvitationTypeId = exports.initInvitationType = void 0;

var _reduxAct = require("redux-act");

var PREFIX = 'COMMON/GIFT/INVITATION_TYPE';
var initInvitationType = (0, _reduxAct.createAction)("".concat(PREFIX, "/INIT_INVITATION_TYPE"));
exports.initInvitationType = initInvitationType;
var selectInvitationTypeId = (0, _reduxAct.createAction)("".concat(PREFIX, "/SELECT_INVITATION_TYPE_ID"));
exports.selectInvitationTypeId = selectInvitationTypeId;
var getInvitationTypes = (0, _reduxAct.createAction)("".concat(PREFIX, "/GET_INVITATION_TYPES_REQUEST"));
exports.getInvitationTypes = getInvitationTypes;
var getInvitationTypesSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/GET_INVITATION_TYPES_SUCCESS"));
exports.getInvitationTypesSuccess = getInvitationTypesSuccess;
var getInvitationTypesFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/GET_INVITATION_TYPES_FAIL"));
exports.getInvitationTypesFail = getInvitationTypesFail;
var saveInvitationType = (0, _reduxAct.createAction)("".concat(PREFIX, "/SAVE_INVITATION_TYPE_REQUEST"), function (payload) {
  return payload;
}, function (_ref) {
  var _ref$returnAddress = _ref.returnAddress,
      returnAddress = _ref$returnAddress === void 0 ? null : _ref$returnAddress,
      _ref$deliveryAddress = _ref.deliveryAddress,
      deliveryAddress = _ref$deliveryAddress === void 0 ? null : _ref$deliveryAddress;
  return {
    returnAddress,
    deliveryAddress
  };
});
exports.saveInvitationType = saveInvitationType;
var saveInvitationTypeSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/SAVE_INVITATION_TYPE_SUCCESS"));
exports.saveInvitationTypeSuccess = saveInvitationTypeSuccess;
var saveInvitationTypeFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/SAVE_INVITATION_TYPE_FAIL"));
exports.saveInvitationTypeFail = saveInvitationTypeFail;
var editInvitationType = (0, _reduxAct.createAction)("".concat(PREFIX, "/EDIT_INVITATION_TYPE"));
exports.editInvitationType = editInvitationType;
var resetInvitationType = (0, _reduxAct.createAction)("".concat(PREFIX, "/RESET_INVITATION_TYPE"));
exports.resetInvitationType = resetInvitationType;
var clearError = (0, _reduxAct.createAction)("".concat(PREFIX, "/CLEAR_ERROR"));
exports.clearError = clearError;
var clearErrors = (0, _reduxAct.createAction)("".concat(PREFIX, "/CLEAR_ERRORS"));
exports.clearErrors = clearErrors;